import { useHistory } from "react-router-dom";

import IcServiceMain from "assets/svg/IcPayServiceMain.svg";

import {
  Container,
} from "components/Service.style";

import { useEffect, useState } from "react";
import { EventHeaderContainer, EventHeaderImg, EventHeaderSection, EventHeaderTitle } from "../EventStyle.style";
import { EventContentContainer, EventFooterBtn, EventFormContainer, EventFormEachContainer, EventFormEachTitle, EventFormNamePhoneTextContainer, EventFormNamePhoneTitle, EventFormSection, EventSection, EventSubmitBtn, FooterContainer } from "./order/EventSubmit.style";
import { InputText } from "components/home/CommonCriminal/CommonCriminal.style";
import { Checkbox, CheckboxGroup } from "components/home/CommonCriminal/CheckBox";

import DaumPostcode from "react-daum-postcode";

import {
  Modal,
} from "antd";

import { useRecoilState } from "recoil";
import { to3DataState } from "states/atoms";

const EventPayServiceCenter = ({ loggedInUser }) => {
  const history = useHistory();
  const [to3Data, setTo3Data] = useRecoilState(to3DataState);

  const onClickBtn = () => {
    setTo3Data(data);
    history.push("/3o3/pay/certificate");
  }

  const [billingAmount, setBillingAmount] = useState("");

  const handleBillingAmountChange = (e) => {
    const inputValue = e.target.value;
    setBillingAmount(inputValue)
  }

  const [opponentAddress, setOpponentAddress] = useState("");

  const handleOpponentAddressChange = (e) => {
    const inputValue = e.address;
    setOpponentAddress(inputValue)
    setIsModalOpen(false);
  }

  const [opponentName, setOpponentName] = useState("");

  const handleOpponentNameChange = (e) => {
    const inputValue = e.target.value;
    setOpponentName(inputValue)
  }

  const [opponentPhone, setOpponentPhone] = useState("");

  const handleOpponentPhoneChange = (e) => {
    const inputValue = e.target.value;
    setOpponentPhone(inputValue)
  }


  const [desiredResult, setDesiredResult] = useState([]);

  const [isModalOpen, setIsModalOpen] = useState(false);

  const showModal = () => {
    setIsModalOpen(true);
  };

  const closeModal = () => {
    setIsModalOpen(false);
  };

  const isSubmitReady = () => {
    if ((opponentAddress !== "" || opponentPhone !== "") &&
      billingAmount !== "" && opponentName !== "") {
      return true
    }
    return false
  }

  const data = {
    opponentAddress: opponentAddress,
    opponentName: opponentName,
    opponentPhone: opponentPhone,
    billingAmount: billingAmount
  }

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);
  return (
    <Container>
      <EventSection>
        <EventContentContainer>
          <EventHeaderSection>
            <EventHeaderContainer>
              <EventHeaderImg src={IcServiceMain} />
              <EventHeaderTitle>
                임금체불 해결하기
              </EventHeaderTitle>
            </EventHeaderContainer>
          </EventHeaderSection>
          <EventFormSection>
            <EventFormContainer>
              <EventFormEachContainer>
                <EventFormEachTitle>
                  체불된 임금은 얼마인가요?
                </EventFormEachTitle>
                <EventFormNamePhoneTextContainer>
                  <InputText
                    value={billingAmount}
                    type="number"
                    inputMode="numeric"
                    onChange={handleBillingAmountChange}
                    placeholder="월급 또는 퇴직금 총액" />
                </EventFormNamePhoneTextContainer>
              </EventFormEachContainer>
              <EventFormEachContainer>
                <EventFormEachTitle>
                  회사 또는 대표자의 이름
                </EventFormEachTitle>
                <EventFormNamePhoneTextContainer>
                  <InputText
                    value={opponentName}
                    onChange={handleOpponentNameChange}
                    placeholder="회사 또는 대표자의 이름" />
                </EventFormNamePhoneTextContainer>
              </EventFormEachContainer>
              <EventFormEachContainer>
                <EventFormEachTitle>
                  아래 정보중 알고계신 것을<br />
                  하나 이상 선택해 주세요.
                </EventFormEachTitle>
                <CheckboxGroup
                  label=""
                  values={desiredResult}
                  onChange={setDesiredResult}
                >
                  <Checkbox value="회사 또는 대표자의 연락처">회사 또는 대표자의 연락처</Checkbox>
                  {desiredResult.includes("회사 또는 대표자의 연락처") && <>
                    <InputText value={opponentPhone} onChange={handleOpponentPhoneChange} placeholder="회사 또는 대표자의 연락처" />
                  </>}
                  <Checkbox value="회사 또는 대표자의 주소">회사 또는 대표자의 주소</Checkbox>
                  {desiredResult.includes("회사 또는 대표자의 주소") && <>
                    <Modal
                      title="주소 검색"
                      open={isModalOpen}
                      onCancel={closeModal}
                      footer={null}
                    >
                      <DaumPostcode onComplete={handleOpponentAddressChange} />
                    </Modal>
                    <InputText value={opponentAddress} onClick={showModal} placeholder="주소 선택" />
                  </>}
                </CheckboxGroup>
              </EventFormEachContainer>
            </EventFormContainer>
          </EventFormSection>
        </EventContentContainer>
        <FooterContainer>
          <EventFooterBtn active={isSubmitReady()} disabled={!isSubmitReady()} onClick={() => onClickBtn()}>
            다음
          </EventFooterBtn>
        </FooterContainer>
      </EventSection>
    </Container>
  )
};

export default EventPayServiceCenter;